import React from 'react'
import { KTIcon } from '../../Ihouse/helpers'

type Props = {
  experience: string
  rating: string
  remark: string
}

function FeedbackModal({remark, experience, rating}: Props) {
  return (
    <div
      className='modal fade'
      id='feedbackModal'
      tabIndex={-1}
      aria-labelledby='feedbackModalLabel'
      aria-hidden='true'
    >
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title' id='feedbackModalLabel'>
              Feedback Details
            </h5>
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-label='Close'
            />
          </div>
          <div className='modal-body'>
            <div className='mb-3'>
              <label className='form-label fw-bold'>Customer Experience:</label>
              <p id='customerExperience' className='mb-0'>
                {experience}
              </p>
            </div>
            <div className='mb-3'>
              <label className='form-label fw-bold'>Rating:</label>
              <p id='rating' className='mb-0'>
                {new Array(rating || 1).fill(0).map(() => {
                  return <KTIcon iconName='star' className='fs-3 text-warning' />
                })}
              </p>
            </div>
            <div className='mb-3'>
              <label className='form-label fw-bold'>Remark:</label>
              <p id='remark' className='mb-0'>
                {remark}
              </p>
            </div>
          </div>
          <div className='modal-footer'>
            <button type='button' className='btn btn-secondary' data-bs-dismiss='modal'>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeedbackModal
